<template>
  <div class="fs-db-18 text-center py-gd-half" :style="BackgroundPoweredBy">
    Powered By <img class="mx-4" src="@assets/images/logo/logo-powered-by/Logo_mwe_sm.webp" alt="MakeWebEasy Logo" width="16" height="16">
    <a href="https://www.makewebeasy.com" target="_blank" title="MakeWebEasy" :style="{ color: '#28BEE3' }">MakeWebEasy</a> 
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import color from "@helpers/color.helper";
export default {

  computed:{
    ...mapGetters({
      siteComponents: "designIframe/metadata/siteComponents",
    }),
    BackgroundPoweredBy(){
      return {
        color: '#B1B9C1',
        'background-color': color.getColor(this.siteComponents.FOOTER_BAR.style.backgroundColor, this.siteComponents.FOOTER_BAR.style.backgroundColorAlpha),
      };
    }
  }
}
</script>

<style>

</style>